import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import _ from 'lodash';

import JobPage from '../components/company/job-page';
import NotFound from '../components/company/not-found';

const JobRoute = ({ job, errors }) => {
  if (errors.length !== 0) {
    return (
      <Fragment>
        <DocumentTitle title="Not Found | NerdWallet" />
        <NotFound errorType="job" />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <DocumentTitle title={`${_.get(job, 'title', '')} | NerdWallet`} />
      <JobPage job={job} />
    </Fragment>
  );
};

JobRoute.displayName = 'Job Route';
JobRoute.analyticsName = 'job_page';

JobRoute.propTypes = {
  job: PropTypes.object.isRequired,
  errors: PropTypes.object,
};

export default connect((state) => ({
  job: state.careersData.job,
  errors: state.errors,
}))(JobRoute);
